/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubbleEmail_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly " $refType": "PdpSharedIconBubbleEmail_user";
};
export type PdpSharedIconBubbleEmail_user$data = PdpSharedIconBubbleEmail_user;
export type PdpSharedIconBubbleEmail_user$key = {
    readonly " $data"?: PdpSharedIconBubbleEmail_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedIconBubbleEmail_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '96e6b4733ec67b07b621e74786faffd4';
export default node;
